import { Add } from "@mui/icons-material";
import {
  AutocompleteRenderInputParams,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface ITranslationPathInputProps {
  params: AutocompleteRenderInputParams;
  isLoading: boolean;
}

/**
 * Input rendered by the path autocomplete — adds the leading search icon and a
 * trailing loading spinner while the key index is still being fetched.
 */
export const TranslationPathInput: FC<ITranslationPathInputProps> = ({
  params,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      {...params}
      size="small"
      placeholder={t("systemParam.customTranslations.searchKeyPlaceholder")}
      slotProps={{
        ...params.slotProps,
        input: {
          ...params.slotProps.input,
          startAdornment: (
            <InputAdornment position="start">
              <Add fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: (
            <>
              {isLoading ? (
                <CircularProgress color="inherit" size={16} />
              ) : null}
              {params.slotProps.input.endAdornment}
            </>
          ),
        },
      }}
    />
  );
};
